import { TS_AddonVisa }         from '../TravelSeller/Models/TS_AddonVisa';
import { BookingItemInterface } from './BookingItemInterface';

export class AddonVisa extends TS_AddonVisa implements BookingItemInterface {
}